import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Teleport as _Teleport, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, vModelCheckbox as _vModelCheckbox, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-570f4265"),n=n(),_popScopeId(),n)
const _hoisted_1 = { ref: "popupContainer" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "tab-strip-menu" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col-8" }
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "col-12 d-flex justify-content-between" }
const _hoisted_8 = ["disabled"]
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" Create New Order ")
const _hoisted_10 = {
  ref: "form",
  class: "tps-form"
}
const _hoisted_11 = { class: "row" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-3 text-end fw-bold" }, "Id", -1))
const _hoisted_13 = { class: "col-9 text-start" }
const _hoisted_14 = {
  key: 0,
  class: "row"
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-3 text-end fw-bold" }, [
  /*#__PURE__*/_createTextVNode("Branch"),
  /*#__PURE__*/_createElementVNode("sup", { class: "mandatory" }, "*")
], -1))
const _hoisted_16 = { class: "col-9 text-start" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  value: "null",
  selected: "",
  disabled: ""
}, "Select a branch...", -1))
const _hoisted_18 = ["value"]
const _hoisted_19 = { class: "row" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-3 text-end fw-bold" }, [
  /*#__PURE__*/_createTextVNode("Email"),
  /*#__PURE__*/_createElementVNode("sup", { class: "mandatory" }, "*")
], -1))
const _hoisted_21 = { class: "col-9 text-start" }
const _hoisted_22 = { class: "row" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-3 text-end fw-bold" }, [
  /*#__PURE__*/_createTextVNode("First Name"),
  /*#__PURE__*/_createElementVNode("sup", { class: "mandatory" }, "*")
], -1))
const _hoisted_24 = { class: "col-9 text-start" }
const _hoisted_25 = { class: "row" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-3 text-end fw-bold" }, [
  /*#__PURE__*/_createTextVNode("Last Name"),
  /*#__PURE__*/_createElementVNode("sup", { class: "mandatory" }, "*")
], -1))
const _hoisted_27 = { class: "col-9 text-start" }
const _hoisted_28 = { class: "row" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-3 text-end fw-bold" }, "Phone Number", -1))
const _hoisted_30 = { class: "col-9 text-start" }
const _hoisted_31 = { class: "row" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-3 text-end fw-bold" }, "Mobile Number", -1))
const _hoisted_33 = { class: "col-9 text-start" }
const _hoisted_34 = { class: "row" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-3 text-end fw-bold" }, "Relay Top Folder Note", -1))
const _hoisted_36 = { class: "col-9 text-start" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "invalid-feedback" }, "Must be 16 characters or less", -1))
const _hoisted_38 = { class: "row" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-3 text-end fw-bold" }, "Relay Sub Folder Note", -1))
const _hoisted_40 = { class: "col-9 text-start" }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "invalid-feedback" }, "Must be 16 characters or less", -1))
const _hoisted_42 = { class: "row" }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-3 text-end fw-bold" }, "Ecommerce merchant", -1))
const _hoisted_44 = { class: "col-9 text-start" }
const _hoisted_45 = { class: "form-check form-switch" }
const _hoisted_46 = { class: "row" }
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-3 text-end fw-bold" }, "Is API Enabled", -1))
const _hoisted_48 = { class: "col-9 text-start" }
const _hoisted_49 = { class: "form-check form-switch" }
const _hoisted_50 = { class: "row" }
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-3 text-end fw-bold" }, "CreativeHub Book Included", -1))
const _hoisted_52 = { class: "col-9 text-start" }
const _hoisted_53 = { class: "form-check form-switch" }
const _hoisted_54 = {
  key: 1,
  class: "row"
}
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-3 text-end fw-bold" }, "Branch", -1))
const _hoisted_56 = { class: "col-9 text-start" }
const _hoisted_57 = { class: "row" }
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-3 text-end fw-bold" }, "Shipping Address", -1))
const _hoisted_59 = { class: "col-9 text-start" }
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  key: "0",
  value: "0"
}, "Add New...", -1))
const _hoisted_61 = ["value"]
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row mt-2" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "offset-3 col-9 fw-bold" }, [
    /*#__PURE__*/_createElementVNode("h4", null, "Shipping address")
  ])
], -1))
const _hoisted_63 = { class: "row" }
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-3 text-end fw-bold" }, "First Name", -1))
const _hoisted_65 = { class: "col-9 text-start" }
const _hoisted_66 = { class: "row" }
const _hoisted_67 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-3 text-end fw-bold" }, "Last Name", -1))
const _hoisted_68 = { class: "col-9 text-start" }
const _hoisted_69 = { class: "row" }
const _hoisted_70 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-3 text-end fw-bold" }, "Address Line 1", -1))
const _hoisted_71 = { class: "col-9 text-start" }
const _hoisted_72 = { class: "row" }
const _hoisted_73 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-3 text-end fw-bold" }, "Address Line 2", -1))
const _hoisted_74 = { class: "col-9 text-start" }
const _hoisted_75 = { class: "row" }
const _hoisted_76 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-3 text-end fw-bold" }, "Town", -1))
const _hoisted_77 = { class: "col-9 text-start" }
const _hoisted_78 = { class: "row" }
const _hoisted_79 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-3 text-end fw-bold" }, "County", -1))
const _hoisted_80 = { class: "col-9 text-start" }
const _hoisted_81 = { class: "row" }
const _hoisted_82 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-3 text-end fw-bold" }, "Post Code", -1))
const _hoisted_83 = { class: "col-9 text-start" }
const _hoisted_84 = { class: "row" }
const _hoisted_85 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-3 text-end fw-bold" }, "Country", -1))
const _hoisted_86 = { class: "col-9 text-start" }
const _hoisted_87 = ["value"]
const _hoisted_88 = { class: "row" }
const _hoisted_89 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-3 text-end fw-bold" }, "Phone Number", -1))
const _hoisted_90 = { class: "col-9 text-start" }
const _hoisted_91 = { class: "row" }
const _hoisted_92 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-3 text-end fw-bold" }, "Use as default address", -1))
const _hoisted_93 = { class: "col-9 text-start" }
const _hoisted_94 = { class: "form-check form-switch" }
const _hoisted_95 = {
  key: 0,
  class: "col-4"
}
const _hoisted_96 = {
  key: 0,
  class: "row"
}
const _hoisted_97 = { class: "col-12" }
const _hoisted_98 = {
  key: 0,
  class: "row"
}
const _hoisted_99 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-md-12 d-flex justify-content-center" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "spinner-border" })
], -1))
const _hoisted_100 = [
  _hoisted_99
]
const _hoisted_101 = { ref: "grid" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_GenericModalVue = _resolveComponent("GenericModalVue")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_notes_list = _resolveComponent("notes-list")!
  const _component_CustomerProducts = _resolveComponent("CustomerProducts")!
  const _component_CustomerInvoices = _resolveComponent("CustomerInvoices")!
  const _component_CustomerSales = _resolveComponent("CustomerSales")!
  const _component_KTabStrip = _resolveComponent("KTabStrip")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, null, 512),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      _createVNode(_component_GenericModalVue, {
        show: _ctx.showWarningModal,
        "body-text": _ctx.warningModalText,
        "header-text": 'WARNING!!!',
        "is-question": false,
        "is-warning": true,
        onClose: _ctx.onWarningModalClose
      }, null, 8, ["show", "body-text", "onClose"])
    ])),
    _createElementVNode("div", _hoisted_2, [
      (_ctx.message)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass(["alert", `alert-${_ctx.msgClass}`])
          }, _toDisplayString(_ctx.message), 3))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_KTabStrip, {
          selected: _ctx.selectedTab,
          "tab-position": 'top',
          tabs: _ctx.tabs,
          onSelect: _ctx.onSelectTab
        }, {
          details: _withCtx(() => [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("button", {
                      class: "btn btn-warning",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.saveCustomer())),
                      disabled: !_ctx.isValidForm
                    }, " Save ", 8, _hoisted_8),
                    (!_ctx.newCustomer)
                      ? (_openBlock(), _createBlock(_component_router_link, {
                          key: 0,
                          class: "btn btn-success",
                          to: `/new-order/${_ctx.$route.params.customerId}`
                        }, {
                          default: _withCtx(() => [
                            _hoisted_9
                          ]),
                          _: 1
                        }, 8, ["to"]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("form", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _hoisted_12,
                    _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.customer.Id), 1)
                  ]),
                  (_ctx.newCustomer)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                        _hoisted_15,
                        _createElementVNode("div", _hoisted_16, [
                          _withDirectives(_createElementVNode("select", {
                            class: "form-control",
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.newUserBranchId) = $event)),
                            required: ""
                          }, [
                            _hoisted_17,
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.branches, (branch) => {
                              return (_openBlock(), _createElementBlock("option", {
                                key: branch.Id,
                                value: branch.Id
                              }, _toDisplayString(branch.Name), 9, _hoisted_18))
                            }), 128))
                          ], 512), [
                            [_vModelSelect, _ctx.newUserBranchId]
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_19, [
                    _hoisted_20,
                    _createElementVNode("div", _hoisted_21, [
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.customer.Email) = $event)),
                        type: "email",
                        class: "form-control"
                      }, null, 512), [
                        [_vModelText, _ctx.customer.Email]
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_22, [
                    _hoisted_23,
                    _createElementVNode("div", _hoisted_24, [
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.customer.FirstName) = $event)),
                        type: "text",
                        class: "form-control"
                      }, null, 512), [
                        [_vModelText, _ctx.customer.FirstName]
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_25, [
                    _hoisted_26,
                    _createElementVNode("div", _hoisted_27, [
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.customer.LastName) = $event)),
                        type: "text",
                        class: "form-control"
                      }, null, 512), [
                        [_vModelText, _ctx.customer.LastName]
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_28, [
                    _hoisted_29,
                    _createElementVNode("div", _hoisted_30, [
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.customer.PhoneNumber) = $event)),
                        type: "text",
                        class: "form-control"
                      }, null, 512), [
                        [_vModelText, _ctx.customer.PhoneNumber]
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_31, [
                    _hoisted_32,
                    _createElementVNode("div", _hoisted_33, [
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.customer.MobileNumber) = $event)),
                        type: "text",
                        class: "form-control"
                      }, null, 512), [
                        [_vModelText, _ctx.customer.MobileNumber]
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_34, [
                    _hoisted_35,
                    _createElementVNode("div", _hoisted_36, [
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.customer.RelayTopFolderNote) = $event)),
                        class: "form-control",
                        type: "text",
                        maxlength: "16"
                      }, null, 512), [
                        [_vModelText, _ctx.customer.RelayTopFolderNote]
                      ])
                    ]),
                    _hoisted_37
                  ]),
                  _createElementVNode("div", _hoisted_38, [
                    _hoisted_39,
                    _createElementVNode("div", _hoisted_40, [
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.customer.RelaySubFolderNote) = $event)),
                        class: "form-control",
                        type: "text",
                        maxlength: "16"
                      }, null, 512), [
                        [_vModelText, _ctx.customer.RelaySubFolderNote]
                      ]),
                      _hoisted_41
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_42, [
                    _hoisted_43,
                    _createElementVNode("div", _hoisted_44, [
                      _createElementVNode("div", _hoisted_45, [
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.customer.IsMerchant) = $event)),
                          class: "form-check-input",
                          type: "checkbox"
                        }, null, 512), [
                          [_vModelCheckbox, _ctx.customer.IsMerchant]
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_46, [
                    _hoisted_47,
                    _createElementVNode("div", _hoisted_48, [
                      _createElementVNode("div", _hoisted_49, [
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.customer.IsApiEnabled) = $event)),
                          class: "form-check-input",
                          type: "checkbox"
                        }, null, 512), [
                          [_vModelCheckbox, _ctx.customer.IsApiEnabled]
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_50, [
                    _hoisted_51,
                    _createElementVNode("div", _hoisted_52, [
                      _createElementVNode("div", _hoisted_53, [
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.customer.HasTPSBook) = $event)),
                          class: "form-check-input",
                          type: "checkbox"
                        }, null, 512), [
                          [_vModelCheckbox, _ctx.customer.HasTPSBook]
                        ])
                      ])
                    ])
                  ]),
                  (!_ctx.newCustomer)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_54, [
                        _hoisted_55,
                        _createElementVNode("div", _hoisted_56, _toDisplayString(_ctx.getBranchName()), 1)
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_57, [
                    _hoisted_58,
                    _createElementVNode("div", _hoisted_59, [
                      _withDirectives(_createElementVNode("select", {
                        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.shippingAddressId) = $event)),
                        class: "form-control"
                      }, [
                        _hoisted_60,
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.customer.ShippingAddresses, (item) => {
                          return (_openBlock(), _createElementBlock("option", {
                            key: item.Id,
                            value: item.Id
                          }, _toDisplayString(item.AddressOnOneLine), 9, _hoisted_61))
                        }), 128))
                      ], 512), [
                        [_vModelSelect, _ctx.shippingAddressId]
                      ])
                    ])
                  ]),
                  _hoisted_62,
                  _createElementVNode("div", _hoisted_63, [
                    _hoisted_64,
                    _createElementVNode("div", _hoisted_65, [
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.customer.ShippingAddress.FirstName) = $event)),
                        type: "text",
                        class: "form-control"
                      }, null, 512), [
                        [_vModelText, _ctx.customer.ShippingAddress.FirstName]
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_66, [
                    _hoisted_67,
                    _createElementVNode("div", _hoisted_68, [
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.customer.ShippingAddress.LastName) = $event)),
                        type: "text",
                        class: "form-control"
                      }, null, 512), [
                        [_vModelText, _ctx.customer.ShippingAddress.LastName]
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_69, [
                    _hoisted_70,
                    _createElementVNode("div", _hoisted_71, [
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.customer.ShippingAddress.Line1) = $event)),
                        type: "text",
                        class: "form-control"
                      }, null, 512), [
                        [_vModelText, _ctx.customer.ShippingAddress.Line1]
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_72, [
                    _hoisted_73,
                    _createElementVNode("div", _hoisted_74, [
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.customer.ShippingAddress.Line2) = $event)),
                        type: "text",
                        class: "form-control"
                      }, null, 512), [
                        [_vModelText, _ctx.customer.ShippingAddress.Line2]
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_75, [
                    _hoisted_76,
                    _createElementVNode("div", _hoisted_77, [
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.customer.ShippingAddress.Town) = $event)),
                        type: "text",
                        class: "form-control"
                      }, null, 512), [
                        [_vModelText, _ctx.customer.ShippingAddress.Town]
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_78, [
                    _hoisted_79,
                    _createElementVNode("div", _hoisted_80, [
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.customer.ShippingAddress.County) = $event)),
                        type: "text",
                        class: "form-control"
                      }, null, 512), [
                        [_vModelText, _ctx.customer.ShippingAddress.County]
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_81, [
                    _hoisted_82,
                    _createElementVNode("div", _hoisted_83, [
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.customer.ShippingAddress.PostCode) = $event)),
                        type: "text",
                        class: "form-control"
                      }, null, 512), [
                        [_vModelText, _ctx.customer.ShippingAddress.PostCode]
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_84, [
                    _hoisted_85,
                    _createElementVNode("div", _hoisted_86, [
                      _withDirectives(_createElementVNode("select", {
                        "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.customer.ShippingAddress.CountryId) = $event)),
                        class: "form-control"
                      }, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.countries, (item) => {
                          return (_openBlock(), _createElementBlock("option", {
                            key: item.Id,
                            value: item.Id
                          }, _toDisplayString(item.Name), 9, _hoisted_87))
                        }), 128))
                      ], 512), [
                        [_vModelSelect, _ctx.customer.ShippingAddress.CountryId]
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_88, [
                    _hoisted_89,
                    _createElementVNode("div", _hoisted_90, [
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.customer.ShippingAddress.PhoneNumber) = $event)),
                        type: "text",
                        class: "form-control"
                      }, null, 512), [
                        [_vModelText, _ctx.customer.ShippingAddress.PhoneNumber]
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_91, [
                    _hoisted_92,
                    _createElementVNode("div", _hoisted_93, [
                      _createElementVNode("div", _hoisted_94, [
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.customer.ShippingAddress.UseAsDefaultBillingAddress) = $event)),
                          class: "form-check-input",
                          type: "checkbox"
                        }, null, 512), [
                          [_vModelCheckbox, _ctx.customer.ShippingAddress.UseAsDefaultBillingAddress]
                        ])
                      ])
                    ])
                  ])
                ], 512)
              ]),
              (!_ctx.newCustomer)
                ? (_openBlock(), _createElementBlock("div", _hoisted_95, [
                    _createVNode(_component_notes_list, {
                      notes: _ctx.notes,
                      type: _ctx.OrderNoteType.User,
                      "parent-id": _ctx.customer.Id,
                      "customer-id": _ctx.customer.Id,
                      onNoteAdded: _ctx.noteAdded,
                      onNoteUpdated: _ctx.noteUpdated,
                      onNoteDeleted: _ctx.noteDeleted
                    }, null, 8, ["notes", "type", "parent-id", "customer-id", "onNoteAdded", "onNoteUpdated", "onNoteDeleted"])
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          orders: _withCtx(() => [
            (!_ctx.newCustomer)
              ? (_openBlock(), _createElementBlock("div", _hoisted_96, [
                  _createElementVNode("div", _hoisted_97, [
                    (_ctx.isLoading)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_98, _hoisted_100))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_101, null, 512)
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          products: _withCtx(() => [
            (_ctx.selectedTab === 2)
              ? (_openBlock(), _createBlock(_component_CustomerProducts, {
                  key: 0,
                  "user-id": _ctx.$route.params.customerId
                }, null, 8, ["user-id"]))
              : _createCommentVNode("", true)
          ]),
          invoices: _withCtx(() => [
            (_ctx.selectedTab === 3)
              ? (_openBlock(), _createBlock(_component_CustomerInvoices, {
                  key: 0,
                  "user-id": _ctx.$route.params.customerId
                }, null, 8, ["user-id"]))
              : _createCommentVNode("", true)
          ]),
          sales: _withCtx(() => [
            (_ctx.selectedTab === 3)
              ? (_openBlock(), _createBlock(_component_CustomerSales, {
                  key: 0,
                  "user-id": _ctx.$route.params.customerId
                }, null, 8, ["user-id"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["selected", "tabs", "onSelect"])
      ])
    ])
  ], 64))
}